const Loader = () => {
	return (
		<div style={{ margin: "50px 0" }}>
			<span style={{position: 'unset'}}  className={"active saving-effect saving-effect-type-2"}>
				<span></span>
				<span></span>
				<span></span>
			</span>
		</div>
	);
};

export default Loader;
